import React from "react";
import { DefaultOutboundLink } from "./DefaultLink.component";

const FooterIcon = ({ link, platform, size }) => {
  return (
    <DefaultOutboundLink to={link}>
      <button
        className={`footer-icon ${platform}`}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          cursor: "pointer",
        }}
      />
    </DefaultOutboundLink>
  );
};

const FooterIconBelt = (props) => {
  return (
    <div
      className="d-flex flex-row align-items-center justify-content-around"
      style={{
        width: `${props?.stretchWidth || 50}%`,
      }}
    >
      {Object.keys(props?.socials || {}).map((k) => {
        if (!props?.socials[k]) return null;
        return (
          <FooterIcon
            key={k}
            platform={k}
            link={props?.socials[k]}
            size={props?.size || 20}
          />
        );
      })}
    </div>
  );
};

export default FooterIconBelt;
